import { Component, ViewEncapsulation } from '@angular/core';
import { Certificate } from '../../models/certs/certificates.model';
import { CommunicationService } from '../../shared/services/communication.service';

import { ApiService } from '../../shared/services/api.service';
import { ListBase } from '../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-cert-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html',
  encapsulation: ViewEncapsulation.None
})
export class CertListComponent extends ListBase<Certificate> {

  public url = 'certificates';
  public routePrefix = 'certs';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }

}
